module.exports = __webpack_public_path__ + "static/media/cross-obstacle.ba062b06.svg";